import React from 'react'
import { IdentificacaoBeneficiario } from '../../../../interfaces/entities/ComponenteCadastral/IdentificacaoBeneficiario'
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';

const ComponenteCadastralBeneficiarioData: React.FC<{ identificacaoBeneficiario: IdentificacaoBeneficiario | null }> = ({ identificacaoBeneficiario }) => {

  const accessibility = useAccessibility();
  const font14Style = accessibility.calculateTextStyle(14)
  
  return (
    <div className="registration-data-card-holder margin-top">
      <div className="registration-data-card-service" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
        <div className="registration-data-row">
          <span style={accessibility.textStyleAccessibility} className="registration-data-title">Identificação do beneficiário(a)</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Data de nascimento</span>
          <span style={font14Style} className="registration-data-value">{identificacaoBeneficiario?.dtNascimento}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Acomodação</span>
          <span style={font14Style} className="registration-data-value">{identificacaoBeneficiario?.acomodacao}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Data início cobertura contratual</span>
          <span style={font14Style} className="registration-data-value">{identificacaoBeneficiario?.dtInicioCobertura}</span>
        </div>
        <div className="registration-data-row">
          <span style={font14Style} className="registration-data-key">Data término cobertura parcial temporária</span>
          <span style={font14Style} className="registration-data-value">{identificacaoBeneficiario?.dtTerminoCobertura}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle }}>
          <span style={font14Style} className="registration-data-key">Cartão nacional de saúde</span>
          <span style={font14Style} className="registration-data-value">{identificacaoBeneficiario?.cartaoNacionalSaude}</span>
        </div>
      </div>
    </div>
  )
}

export default ComponenteCadastralBeneficiarioData